import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@mui/material'
import { micPermissionView } from '$comp/main/root.reducer'
import { enableNoSleep } from '$func/no-sleep'
import { vibrate } from '$func/vibrate'
import {
  showMicPermissionDeniedDialog,
  showMicPermissionPromptDialog,
} from '$comp/modals/permission-dialog'
import { MicOffOutlinedIcon, MicOutlinedIcon } from '@weblite/icons'
import { RecorderStatus } from '../../send-field.type'
import { SendFieldIconButton } from '../icon-button'
import { isInWebView } from '$helper/functions/environmentInfo'

export function RecordButton({
  state,
  setRecorderState,
}: {
  state: RecorderStatus
  setRecorderState: (state: RecorderStatus) => unknown
}) {
  const micPermission = useSelector(micPermissionView)
  const disabled = micPermission === 'denied'

  const isStartingRecodrd = state === 'STARTING'

  const requestRecord = useCallback(() => {
    if (!isInWebView) {
      if (micPermission === 'prompt') {
        showMicPermissionPromptDialog()
        return
      } else if (micPermission === 'denied') {
        showMicPermissionDeniedDialog()
        return
      }
    }

    if (!(state === 'STARTING' || state === 'RECORD')) {
      if (disabled) return
      setRecorderState('STARTING')
      enableNoSleep('recorder')
      vibrate()
    }
  }, [state, micPermission, disabled, setRecorderState])

  return (
    <SendFieldIconButton onClick={requestRecord}>
      {disabled ? (
        <MicOffOutlinedIcon sx={{ color: 'neutral500' }} />
      ) : isStartingRecodrd ? (
        <CircularProgress color="inherit" size={22} />
      ) : (
        <MicOutlinedIcon sx={{ color: 'neutral500' }} />
      )}
    </SendFieldIconButton>
  )
}
